import React from 'react';
import './Header.css';

const Header = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <nav className="navbar">
        <div className="logo">Rabin Pandey</div>
        <ul className="nav-links">
          <li><button onClick={() => scrollToSection('home')}>Home</button></li>
          <li><button onClick={() => scrollToSection('about')}>About</button></li>
          <li><button onClick={() => scrollToSection('projects')}>Projects</button></li>
          <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
        </ul>
        <button className="contact-now" onClick={() => scrollToSection('contact')}>
          CONTACT NOW
        </button>
      </nav>
    </header>
  );
};

export default Header;